import moment from "moment";
import React from "react";
import AttachmentContainer from "../../pages/groupChat/attachmentContainer";
import useSendPdfToChat from "../../hooks/useSendPdfToChat";

export const TaskMessage = ({msg, isLoggedInUser}) => {

    const {sendPdfToChat, isSending} = useSendPdfToChat();

    const isOpenInEditor = (mime_type) => {
        if(mime_type == 'pdf' || mime_type == 'application/pdf'){
            return true
        }
    
        return false;
    }

    return (
        <div className={`rounded-md ${isLoggedInUser() ? 'bg-blue-100': 'bg-white border'}  p-2 shadow`}>
            <div className={`text-gray-800 text-start`}>
                <h1 className={`flex gap-2 justify-between capitalize font-bold border-b }  py-1 px-2 rounded-t-md`}>
                    Task Created
                </h1>
                <div className={`p-2 rounded-b-md`}>
                    <p>On: {moment(msg.message.data?.start_time).format('MM/DD/YYYY hh:mm A')}</p>
                </div>
            </div>
            
            {msg?.message?.media?.length ?
                <div className="mt-2">
                    <AttachmentContainer data={{...msg, files: msg?.message?.media}} openInEditor={isOpenInEditor(msg?.message?.media[0]?.mime_type)} callBackFun={sendPdfToChat} />
                </div>
                : null
            }
        </div>
    );
};